
import { Options, Vue } from 'vue-class-component'
import { useStore } from '@/store'

@Options({
  props: {
    token: String
  }
})
export default class ServiceLogs extends Vue {
  store = useStore()

  autoScrollLogsToLatest = true

  currentLogListInterval = setInterval(() => {
    if (!this.autoScrollLogsToLatest) {
      return
    }

    const currentLogListElement = document.getElementById('currentLogList')
    if (currentLogListElement && currentLogListElement.lastElementChild) {
      const childElement = currentLogListElement.lastElementChild
      childElement.scrollIntoView()
    }

    const previousLogListElement = document.getElementById('previousLogList')
    if (previousLogListElement && previousLogListElement.lastElementChild) {
      const childElement = previousLogListElement.lastElementChild
      childElement.scrollIntoView()
    }
  }, 500)

  classForLine (line: string): string {
    const lowerCaseLine = line.toLowerCase()
    if (lowerCaseLine.includes('info')) {
      return 'text-info'
    } else if (lowerCaseLine.includes('warn')) {
      return 'text-warning'
    } else if (lowerCaseLine.includes('error') ||
      lowerCaseLine.includes('fatal') ||
      lowerCaseLine.includes('critical')) {
      return 'text-danger'
    }
    return ''
  }

  disableLogScrolling (event: Event): void {
    this.autoScrollLogsToLatest = false
  }
}
